export const USED = "Использован";
export const EXPIRED = "Просрочен";
export const TIME_DOWN = "time-down";
export const TERMINATED = "Отменен";
export const OPENED = "Выдан";
